import React, { useEffect, useState } from 'react';

import './reservedHours.scss';

import ReservationInsightsFilter from '../../interfaces/reservationInsightsFilter';
import HistoricReservationService from '../historicReservationService';
import ChartUtils from './chartUtils';
import LanguageProvider from '@/providers/languageProvider';
import { ReservedTimeResponse } from '../../interfaces/responses/reservedTimeResponse';

interface IReservedHoursProps {
    filter: ReservationInsightsFilter;
}

const ReservedHours: React.FC<IReservedHoursProps> = (props) => {
    const [reservedTime, setReservedTime] = useState<ReservedTimeResponse>();

    const historicReservationService = new HistoricReservationService();

    useEffect(() => {
        historicReservationService.getPlaceReservationsReservedtime(props.filter).then((response) => {

            setReservedTime({ ...response});
        });
    }, [props.filter.triggerUpdate]);

    return (
        <div id="reserved-hours">
            <div className="widget-title">
                {LanguageProvider.getTranslation("pages.realestateutilization.charts.reservedhours.title")}
            </div>
            <div className="reserved-hours-subtitle">
                {LanguageProvider.getTranslation("pages.realestateutilization.charts.reservedhours.subtitle")}
            </div>
            {reservedTime && reservedTime.averageTime && <div className="reserved-hours-time">
                {ChartUtils.formatTime(reservedTime.averageTime)}
            </div>}
            {!(reservedTime && reservedTime.averageTime) && <div className="reserved-hours-time">{ChartUtils.formatTime(0)}</div>}
            <div className="reserved-hours-timeframe">{ChartUtils.formatString(LanguageProvider.getTranslation("pages.realestateutilization.charts.reservedhours.timeframe"), ChartUtils.padLeft(props.filter.startHourOfTheDay, 2), ChartUtils.padLeft(props.filter.endHourOfTheDay, 2))}</div>
        </div>
    );
}

export default ReservedHours;
